<template>
  <div class="service-provider-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/Welcome' }">
            <i class="el-icon-s-home"></i> 首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <i class="el-icon-office-building"></i> 服务商管理
          </el-breadcrumb-item>
          <el-breadcrumb-item>服务商列表</el-breadcrumb-item>
        </el-breadcrumb>
        <h2 class="page-title">
          <i class="el-icon-tickets"></i> 服务商列表
          <span class="badge-count">{{ total }}</span>
        </h2>
      </div>
      <div class="header-right">
        <el-button
                type="primary"
                icon="el-icon-plus"
                size="small"
                @click="addData"
                class="add-btn"
        >
          新增服务商
        </el-button>
      </div>
    </div>

    <!-- 搜索和筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-header">
        <i class="el-icon-search filter-icon"></i>
        <span class="filter-title">筛选查询</span>
      </div>

      <el-form
              size="small"
              :inline="true"
              :model="searchForm"
              ref="searchForRef"
              class="filter-form"
      >
        <div class="filter-row">
          <el-form-item label="所属省份">
            <el-input
                    v-model="searchForm.province"
                    placeholder="请输入省份"
                    clearable
                    prefix-icon="el-icon-location"
            ></el-input>
          </el-form-item>

          <el-form-item label="客商名称">
            <el-input
                    v-model="searchForm.name"
                    placeholder="请输入客商名称"
                    clearable
                    prefix-icon="el-icon-office-building"
            ></el-input>
          </el-form-item>

          <el-form-item label="编号">
            <el-input
                    v-model="searchForm.sn"
                    placeholder="请输入编号"
                    clearable
                    prefix-icon="el-icon-document"
            ></el-input>
          </el-form-item>
        </div>

        <div class="filter-row">
          <el-form-item label="类型">
            <el-input
                    v-model="searchForm.type"
                    placeholder="请输入类型"
                    clearable
                    prefix-icon="el-icon-price-tag"
            ></el-input>
          </el-form-item>

          <el-form-item label="类别">
            <el-select
                    v-model="searchForm.grade_id"
                    placeholder="请选择类别"
                    clearable
                    style="width: 200px;"
            >
              <el-option
                      v-for="item in gradeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="action-buttons">
            <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit"
                    class="search-btn"
            >
              搜索
            </el-button>
            <el-button
                    icon="el-icon-refresh"
                    @click="resetSearch"
                    class="reset-btn"
            >
              重置
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-card>

    <!-- 数据表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-header-left">
          <i class="el-icon-s-data table-icon"></i>
          <span class="table-title">服务商列表</span>
          <el-tag type="info" size="small">共 {{ total }} 条记录</el-tag>
          <el-tooltip content="展开全部" placement="top">
            <el-button
                    type="text"
                    icon="el-icon-caret-bottom"
                    size="mini"
                    @click="expandAll"
                    class="expand-btn"
            >
              展开
            </el-button>
          </el-tooltip>
          <el-tooltip content="折叠全部" placement="top">
            <el-button
                    type="text"
                    icon="el-icon-caret-right"
                    size="mini"
                    @click="collapseAll"
                    class="collapse-btn"
            >
              折叠
            </el-button>
          </el-tooltip>
        </div>
        <div class="table-header-right">
          <el-tooltip content="刷新数据" placement="top">
            <el-button
                    icon="el-icon-refresh"
                    size="small"
                    circle
                    @click="DataList"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="导出数据" placement="top">
            <el-button
                    icon="el-icon-download"
                    size="small"
                    circle
            ></el-button>
          </el-tooltip>
        </div>
      </div>

      <el-table
              ref="multipleTable"
              :data="tableLoadData"
              size="small"
              style="width: 100%"
              :row-class-name="tableRowClassName"
              v-loading="loading"
              element-loading-text="数据加载中..."
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 255, 255, 0.8)"
              :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
              row-key="id"
              :default-expand-all="defaultExpandAll"
      >
        <el-table-column
                type="index"
                label="序号"
                width="60"
                align="center"
        >
          <template slot-scope="scope">
            <span class="index-badge">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <!-- 树形展开列 -->
        <el-table-column
                type="expand"
                width="40"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.children && scope.row.children.length" class="children-container">
              <div class="children-header">
                <i class="el-icon-office-building children-icon"></i>
                <span class="children-title">下级代理商 ({{ scope.row.children.length }}个)</span>
              </div>
              <el-table
                      :data="scope.row.children"
                      size="mini"
                      style="width: 100%"
                      class="children-table"
              >
                <el-table-column
                        label="名称"
                        width="180"
                >
                  <template slot-scope="childScope">
                    <div class="child-provider-info">
                      <i class="el-icon-office-building child-icon"></i>
                      <span class="child-name">{{ childScope.row.real_name }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                        label="编码"
                        width="200"
                >
                  <template slot-scope="childScope">
                    <el-tag size="mini" type="info">{{ childScope.row.sn }}</el-tag>
                  </template>
                </el-table-column>

                <el-table-column
                        label="联系人"
                        width="100"
                >
                  <template slot-scope="childScope">
                    <div class="child-contact">
                      <i class="el-icon-user"></i>
                      <span>{{ childScope.row.cont_name || '--' }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                        label="电话"
                        width="160"
                >
                  <template slot-scope="childScope">
                    <div class="child-phone">
                      <i class="el-icon-phone"></i>
                      <span>{{ childScope.row.mobile || '--' }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                        label="操作"
                        width="200"
                        align="center"
                >
                  <template slot-scope="childScope">
                    <div class="child-actions">
                      <el-button
                              type="text"
                              size="mini"
                              icon="el-icon-view"
                              @click="goInfo(childScope.row)"
                              class="child-view-btn"
                      >
                        查看
                      </el-button>
                      <el-button
                              type="text"
                              size="mini"
                              icon="el-icon-edit"
                              @click="goEdit(childScope.row)"
                              class="child-edit-btn"
                      >
                        编辑
                      </el-button>
                      <el-dropdown
                              trigger="click"
                              size="small"
                              @command="(command) => handleCommand(command, childScope.row)"
                      >
                        <el-button
                                type="text"
                                size="small"
                                icon="el-icon-more"
                                class="more-btn"
                        >
                          更多
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                                  icon="el-icon-user"
                                  @click.native="goAddUser(childScope.row)"
                                  command="addUser"
                          >
                            增加管理员
                          </el-dropdown-item>
                          <el-dropdown-item
                                  icon="el-icon-setting"
                                  command="setting"
                          >
                            设置
                          </el-dropdown-item>
                          <el-dropdown-item
                                  icon="el-icon-delete"
                                  divided
                                  command="delete"
                          >
                            删除
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else class="no-children">
              <i class="el-icon-info no-data-icon"></i>
              <span class="no-data-text">暂无下级代理商</span>
            </div>
          </template>
        </el-table-column>

        <!-- 主表列 -->
        <el-table-column
                label="服务商信息"
                width="200"
        >
          <template slot-scope="scope">
            <div class="provider-info">
              <div class="provider-name">
                <i class="el-icon-office-building"></i>
                <span class="name-text">{{ scope.row.real_name }}</span>
                <el-tag
                        v-if="scope.row.children && scope.row.children.length"
                        size="mini"
                        type="success"
                        class="has-children-tag"
                >
                  <i class="el-icon-caret-bottom"></i>
                  {{ scope.row.children.length }} 个子级
                </el-tag>
              </div>
              <div class="provider-sn">
                <el-tag size="mini" type="info">{{ scope.row.sn }}</el-tag>
                <span v-if="scope.row.level" class="level-badge">
                  级别: {{ scope.row.level }}
                </span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
                label="联系人信息"
                width="140"
        >
          <template slot-scope="scope">
            <div class="contact-info">
              <div class="contact-name">
                <i class="el-icon-user"></i>
                <span>{{ scope.row.cont_name || '--' }}</span>
              </div>
              <div class="contact-phone">
                <i class="el-icon-phone"></i>
                <span>{{ scope.row.mobile || '--' }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
                label="区域信息"
                width="180"
        >
          <template slot-scope="scope">
            <div class="region-info">
              <div class="region-item">
                <i class="el-icon-location-outline"></i>
                <span>{{ scope.row.province?.region_name || '--' }}</span>
              </div>
              <div class="region-item">
                <span>{{ scope.row.city?.region_name || '--' }}</span>
              </div>
              <div class="region-item">
                <span>{{ scope.row.district?.region_name || '--' }}</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column
                label="详细地址"
                min-width="200"
        >
          <template slot-scope="scope">
            <div class="address-cell">
              <i class="el-icon-map-location"></i>
              <span class="address-text">{{ scope.row.address || '--' }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
                label="操作"
                width="220"
                fixed="right"
                align="center"
        >
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button
                      type="text"
                      size="small"
                      icon="el-icon-view"
                      @click="goInfo(scope.row)"
                      class="view-btn"
              >
                查看
              </el-button>

              <el-button
                      type="text"
                      size="small"
                      icon="el-icon-edit"
                      @click="goEdit(scope.row)"
                      class="edit-btn"
              >
                编辑
              </el-button>

              <el-button
                      v-if="scope.row.pid === 0"
                      type="text"
                      size="small"
                      icon="el-icon-plus"
                      @click="addChild(scope.row)"
                      class="add-child-btn"
              >
                添加子级
              </el-button>

              <el-dropdown
                      trigger="click"
                      size="small"
                      @command="(command) => handleCommand(command, scope.row)"
              >
                <el-button
                        type="text"
                        size="small"
                        icon="el-icon-more"
                        class="more-btn"
                >
                  更多
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                          icon="el-icon-user"
                          @click.native="goAddUser(scope.row)"
                          command="addUser"
                  >
                    增加管理员
                  </el-dropdown-item>
                  <el-dropdown-item
                          icon="el-icon-setting"
                          command="setting"
                  >
                    设置
                  </el-dropdown-item>
                  <el-dropdown-item
                          icon="el-icon-delete"
                          divided
                          command="delete"
                  >
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 增加管理员弹窗组件 -->
    <eProxyUser
            :formData="formData1"
            :visible.sync="visible1"
            :title="title1"
            :closeForm="closeForm1"
    />
  </div>
</template>

<script>
  import moment from 'moment'
  import eProxyUser from "../common/eProxyUser.vue";

  export default {
    name: "proxyList",
    components: {
      eProxyUser
    },
    data() {
      return {
        formData1: {},
        title1: '',
        visible1: false,
        loading: false,
        defaultExpandAll: false,
        expandKeys: [],

        gradeList: [],
        searchForm: {
          name: "",
          province: "",
          sn: "",
          type: "",
          grade_id: ""
        },
        tableLoadData: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showType: '',
        roleList: [],
        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
        }
      };
    },
    created() {
      this.showType = this.$route.query.showType;
      this.DataList();
      this.departData();
    },
    filters: {
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
      }
    },
    methods: {
      // 展开所有
      expandAll() {
        this.defaultExpandAll = true;
        // 收集所有有子节点的行的key
        const collectKeys = (data) => {
          let keys = [];
          data.forEach(item => {
            if (item.children && item.children.length) {
              keys.push(item.id);
              keys = keys.concat(collectKeys(item.children));
            }
          });
          return keys;
        };
        this.expandKeys = collectKeys(this.tableLoadData);
      },

      // 折叠所有
      collapseAll() {
        this.defaultExpandAll = false;
        this.expandKeys = [];
      },

      // 添加子级代理商
      addChild(row) {
        this.$router.push({
          path: '/proxyForm',
          query: {
            pid: row.id,
            parentName: row.real_name
          }
        });
      },

      // 处理下拉菜单命令
      handleCommand(command, row) {
        switch(command) {
          case 'addUser':
            this.goAddUser(row);
            break;
          case 'setting':
            this.$message.info('设置功能开发中');
            break;
          case 'delete':
            this.$confirm('确定要删除该服务商吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$message.success('删除成功');
            }).catch(() => {});
            break;
        }
      },

      goAddUser(row) {
        this.title1 = "增加管理员";
        this.formData1 = row;
        this.visible1 = true;
      },

      closeForm1() {
        this.title1 = "";
        this.visible1 = false;
      },

      goInfo(row) {
        this.$router.push({
          path: '/proxyInfo',
          query: {
            id: row.id
          }
        });
      },

      goEdit(row) {
        this.$router.push({
          path: '/proxyForm',
          query: {
            id: row.id
          }
        });
      },

      async DataList() {
        this.loading = true;
        try {
          const param = {
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            pid: sessionStorage.getItem('proxy_id')
          };

          const res = await this.$axios.proxyTree(param);
          if (res.code == 200) {
            // 处理树形数据，为每个节点添加hasChildren属性
            const processTreeData = (data) => {
              return data.map(item => {
                const newItem = { ...item };
                // 如果有children属性并且不为空，设置hasChildren为true
                if (newItem.children && newItem.children.length > 0) {
                  newItem.hasChildren = true;
                  // 递归处理子节点
                  newItem.children = processTreeData(newItem.children);
                } else {
                  newItem.hasChildren = false;
                }
                return newItem;
              });
            };

            this.tableLoadData = processTreeData(res.data || []);
            this.total = this.calculateTotalCount(this.tableLoadData);
          }
        } catch (error) {
          console.error(error);
          this.$message.error('数据加载失败');
        } finally {
          this.loading = false;
        }
      },

      // 计算总记录数（包括子节点）
      calculateTotalCount(data) {
        let count = 0;
        const countNodes = (nodes) => {
          nodes.forEach(node => {
            count++;
            if (node.children && node.children.length) {
              countNodes(node.children);
            }
          });
        };
        countNodes(data);
        return count;
      },

      handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.DataList();
      },

      handleCurrentChange(newPage) {
        this.pageNum = newPage;
        this.DataList();
      },

      departData() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        };
        this.$axios.findTree(param).then(res => {
          if (res.code == 200) {
            this.gradeList = res.data.data || [];
          }
        }).catch(error => {
          console.log(error);
        });
      },

      addData() {
        this.$router.push('/proxyForm');
      },

      resetSearch() {
        this.searchForm = {
          name: "",
          province: "",
          sn: "",
          type: "",
          grade_id: ""
        };
        this.pageNum = 1;
        this.DataList();
      },

      searchSubmit() {
        this.pageNum = 1;
        this.DataList();
      },

      tableRowClassName({ rowIndex }) {
        return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
      }
    }
  };
</script>

<style lang="scss" scoped>
  .service-provider-container {
    padding: 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 84px);
  }

  /* 页面头部样式 */
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 16px 24px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);

    .header-left {
      .el-breadcrumb {
        margin-bottom: 8px;

        ::v-deep .el-breadcrumb__item {
          .el-breadcrumb__inner {
            color: #909399;

            &.is-link {
              color: #1890ff;

              &:hover {
                color: #40a9ff;
              }
            }
          }
        }
      }

      .page-title {
        margin: 0;
        font-size: 20px;
        font-weight: 600;
        color: #303133;
        display: flex;
        align-items: center;

        i {
          margin-right: 8px;
          color: #1890ff;
        }

        .badge-count {
          display: inline-block;
          margin-left: 12px;
          padding: 2px 8px;
          background: #1890ff;
          color: white;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 400;
        }
      }
    }

    .header-right {
      .add-btn {
        background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
        border: none;
        border-radius: 20px;
        padding: 8px 16px;

        &:hover {
          opacity: 0.9;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
        }
      }
    }
  }

  /* 筛选卡片样式 */
  .filter-card {
    margin-bottom: 20px;
    border-radius: 8px;
    border: 1px solid #ebeef5;

    .filter-header {
      display: flex;
      align-items: center;
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #ebeef5;

      .filter-icon {
        color: #1890ff;
        font-size: 18px;
        margin-right: 8px;
      }

      .filter-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }

    .filter-form {
      .filter-row {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      ::v-deep .el-form-item {
        margin-bottom: 0;

        .el-form-item__label {
          font-weight: 500;
          color: #606266;
        }
      }

      .action-buttons {
        margin-left: auto;

        .search-btn {
          background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
          border: none;
          border-radius: 4px;
        }

        .reset-btn {
          border-color: #dcdfe6;
          color: #606266;

          &:hover {
            border-color: #1890ff;
            color: #1890ff;
          }
        }
      }
    }
  }

  /* 表格卡片样式 */
  .table-card {
    border-radius: 8px;
    border: 1px solid #ebeef5;

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #ebeef5;

      .table-header-left {
        display: flex;
        align-items: center;
        gap: 12px;

        .table-icon {
          color: #1890ff;
          font-size: 18px;
          margin-right: 4px;
        }

        .table-title {
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          margin-right: 8px;
        }

        .expand-btn,
        .collapse-btn {
          color: #1890ff;
          padding: 4px 8px;

          &:hover {
            background: rgba(24, 144, 255, 0.1);
            border-radius: 4px;
          }
        }
      }

      .table-header-right {
        .el-button {
          margin-left: 8px;
        }
      }
    }
  }

  /* 表格内容样式 */
  ::v-deep .el-table {
    font-size: 14px;

    th {
      background: #fafafa !important;
      color: #333;
      font-weight: 600;
    }

    td {
      padding: 12px 0;
    }

    .even-row {
      background: #fafafa;
    }

    .odd-row {
      background: white;
    }

    .hover-row > td {
      background: #f0f7ff !important;
    }

    // 树形表格箭头样式
    .el-table__expand-icon {
      color: #1890ff;

      &.el-icon-arrow-right:before {
        content: "\e6d9";
      }

      &.el-icon-arrow-right.expanded:before {
        content: "\e6d8";
      }
    }
  }

  /* 子级代理商容器 */
  .children-container {
    padding: 16px;
    background: #fafafa;
    border-radius: 6px;
    margin: 8px;

    .children-header {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      padding-bottom: 8px;
      border-bottom: 1px solid #e8e8e8;

      .children-icon {
        color: #1890ff;
        font-size: 16px;
        margin-right: 8px;
      }

      .children-title {
        font-size: 14px;
        font-weight: 600;
        color: #333;
      }
    }

    .children-table {
      background: transparent;

      ::v-deep .el-table {
        background: transparent;

        th {
          background: #f0f0f0 !important;
        }

        td {
          background: transparent;
        }
      }
    }
  }

  .no-children {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    color: #999;

    .no-data-icon {
      margin-right: 8px;
      font-size: 16px;
    }

    .no-data-text {
      font-size: 14px;
    }
  }

  /* 表格单元格内容样式 */
  .provider-info {
    .provider-name {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      i {
        color: #1890ff;
        margin-right: 6px;
      }

      .name-text {
        font-weight: 500;
        color: #303133;
      }

      .has-children-tag {
        margin-left: 8px;
        background: rgba(82, 196, 26, 0.1);
        border-color: rgba(82, 196, 26, 0.3);
        color: #52c41a;
      }
    }

    .provider-sn {
      display: flex;
      align-items: center;
      gap: 8px;

      .el-tag {
        background: #f0f7ff;
        border-color: #91d5ff;
        color: #1890ff;
      }

      .level-badge {
        font-size: 12px;
        color: #fa8c16;
        background: #fff7e6;
        padding: 1px 6px;
        border-radius: 2px;
      }
    }
  }

  .child-provider-info {
    display: flex;
    align-items: center;

    .child-icon {
      color: #8c8c8c;
      margin-right: 8px;
      font-size: 14px;
    }

    .child-name {
      color: #595959;
    }
  }

  .child-contact,
  .child-phone {
    display: flex;
    align-items: center;

    i {
      color: #8c8c8c;
      margin-right: 6px;
      font-size: 12px;
    }

    span {
      color: #595959;
    }
  }

  .child-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    .child-view-btn {
      color: #1890ff;

      &:hover {
        color: #40a9ff;
      }
    }

    .child-edit-btn {
      color: #52c41a;

      &:hover {
        color: #73d13d;
      }
    }
  }

  .contact-info {
    .contact-name,
    .contact-phone {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      i {
        color: #8c8c8c;
        margin-right: 6px;
        font-size: 12px;
      }

      span {
        color: #595959;
      }
    }
  }

  .region-info {
    .region-item {
      display: flex;
      align-items: center;
      margin-bottom: 2px;
      color: #595959;

      i {
        margin-right: 6px;
        color: #52c41a;
      }
    }
  }

  .address-cell {
    display: flex;
    align-items: flex-start;

    i {
      color: #faad14;
      margin-right: 6px;
      margin-top: 2px;
    }

    .address-text {
      color: #595959;
      line-height: 1.4;
    }
  }

  .index-badge {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background: #f0f7ff;
    color: #1890ff;
    border-radius: 12px;
    font-size: 12px;
  }

  .action-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    .view-btn {
      color: #1890ff;

      &:hover {
        color: #40a9ff;
        background: rgba(24, 144, 255, 0.1);
      }
    }

    .edit-btn {
      color: #52c41a;

      &:hover {
        color: #73d13d;
        background: rgba(82, 196, 26, 0.1);
      }
    }

    .add-child-btn {
      color: #fa8c16;

      &:hover {
        color: #ffa940;
        background: rgba(250, 140, 22, 0.1);
      }
    }

    .more-btn {
      color: #8c8c8c;

      &:hover {
        color: #1890ff;
        background: rgba(24, 144, 255, 0.1);
      }
    }
  }

  /* 分页样式 */
  .pagination-container {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
    margin-top: 20px;
    border-top: 1px solid #ebeef5;

    ::v-deep .el-pagination {
      .el-pagination__total,
      .el-pagination__jump {
        color: #606266;
      }

      .btn-prev,
      .btn-next,
      .el-pager li {
        border-radius: 4px;
        margin: 0 4px;

        &:hover {
          color: #1890ff;
        }
      }

      .el-pager li.active {
        background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
        color: white;

        &:hover {
          color: white;
        }
      }
    }
  }

  /* 响应式设计 */
  @media (max-width: 1200px) {
    .filter-form {
      .filter-row {
        flex-direction: column;

        .el-form-item {
          width: 100%;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .page-header {
      flex-direction: column;
      align-items: flex-start;

      .header-right {
        margin-top: 12px;
        width: 100%;

        .add-btn {
          width: 100%;
        }
      }
    }

    .action-buttons {
      flex-direction: column;
      align-items: stretch;

      .el-button {
        margin-bottom: 4px;
        width: 100%;
        text-align: center;
      }
    }
  }
</style>
